import Skeleton from "@mui/material/Skeleton";

export const AutocompleteSkeleton = () => {
  return (
    <Skeleton
      sx={{
        height: 60,
        borderRadius: "0.5rem",
        transform: "none",
      }}
    />
  );
};
